import React, { Component } from 'react';
import {Paper, Grid, Typography, Button, IconButton, Tooltip} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
import moment from 'moment';
import XLSX from 'xlsx';
import ExcelLogo from '../assets/ExcelLogo';
import FilterBox from './FilterBox';
import { VisibilityRounded, WarningOutlined } from '@material-ui/icons';

export default class OHSCertificateFlags extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            error_message: '',
            querying: true,
            appointments_array: [],
            filtered_assessments_array: [],
            filter_applied: false,
            filter_obj: {},
        }

        this.datasheetFieldSpecs = [
            { field: 'store_code', headerName: 'Branch', width: 110},
            { field: 'branch_appointment_type', headerName: 'OHS Role', width: 240},
            { field: 'employee_number', headerName: 'Empl.#', width: 80, sortable: false},
            { field: 'name', headerName: 'Appointee', width: 160},
            { field: 'job_title', headerName: 'Job Title', width: 140, sortable: false},
            { field: 'reports_to_rom', headerName: 'Manager', width: 120},
            { field: 'qualification_type', headerName: 'Certificate Linked to Appointment', width: 300, sortable: false,renderCell: (parms) => (
                (parms.row.certificate_link_required===1)&&
                <div>
                    {!parms.row.qualification_id_link&&
                    <IconButton disabled={true}>
                        <WarningOutlined color='secondary'/> &nbsp;&nbsp;   <Typography><i>required...</i></Typography>
                    </IconButton>}
                    {parms.row.qualification_id_link&&
                    <span>{parms.row.qualification_type}</span>}
                </div>
            )},
            { field: 'expires', headerName: 'Cert. Expires?', width: 130, sortable: false, renderCell: (parms) => (
                (parms.row.expires)&&
                <span style={{color: -moment().diff(parms.row.expires,'days') < 1 ? '#FF0000' : -moment().diff(parms.row.expires,'days') <= 30 ? '#FF9900' : '#32809a'}}>{parms.row.expires}</span>
            )},
            { field: 'q_file_attachment', headerName: 'Certificate', width: 70, align:'center', sortable:false,
            renderCell: (parms) => (
                (parms.row.q_file_attachment==="YES")&&
                <IconButton
                    onClick={()=>this.viewDoc(parms.row,'cert')} 
                >
                    <Tooltip title="View OHS Certificate">
                        <VisibilityRounded/>
                    </Tooltip>
                </IconButton>
            )},
            { field: 'appointment_date', headerName: 'Appointed?', width: 110, sortable: false},
            { field: 'file_attachment', headerName: 'Appointment Letter', width: 70, align:'center', sortable:false,
            renderCell: (parms) => (
                (parms.row.file_attachment===1)&&
                <IconButton
                    onClick={()=>this.viewDoc(parms.row,'apptmt')} 
                >
                    <Tooltip title="View Appointment Letter">
                        <VisibilityRounded />
                    </Tooltip>
                </IconButton>
            )}
        ]
    }

    componentDidMount = () => {

        Gserv.sendCommand('query_ohs_certificate_flags',this.props.gwt)
        .then(reply=>{
            // console.log('query_ohs_certificate_flags reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_ohs_certificate_flags) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_ohs_certificate_flags) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                
                if (this.state.filter_applied){
                    this.setState({querying:false, appointments_array:reply.certificates_flagged? reply.certificates_flagged : []});
                    if (!reply.Records) {this.setState({filtered_assessments_array:[]})}
                    this.applyFilter(this.state.filter_obj);
                } else {
                    this.setState({querying:false, appointments_array:reply.certificates_flagged?reply.certificates_flagged : [], filtered_assessments_array:reply.certificates_flagged?reply.certificates_flagged : []});
                }
                
            }
        });
    };
    
    resetMe = () => {
        this.setState({error: false,error_message: '',querying: true, appointments_array: []});
        this.componentDidMount();
    }

    exportMe = () => {
        // console.log('called exportMe...');
        if (this.state.filtered_assessments_array.length>0){
            const dateStr = new moment().format("YYYY-MM-DD");
            var ws = XLSX.utils.json_to_sheet(this.state.filtered_assessments_array);
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'OHS Cert Alerts ' + dateStr);
            //Write to browser
            XLSX.writeFile(wb,'TMS Export - OHS Certificate Alerts ' + dateStr + '.xlsx');
        }
    }

    handleFilterChange = (filterObj) => {
        // console.log('filterObj :>> ', filterObj);
        if (filterObj.type==='clear'){
            this.setState({filtered_assessments_array : this.state.appointments_array, filter_obj: {}, filter_applied:false})
        } else {
            this.setState({filter_obj:filterObj});
            this.applyFilter(filterObj);
        }
    }

    applyFilter = (filterObj) => {
        if (this.state.appointments_array.length > 0){
            let temp_array = [];
            switch (filterObj.type) {
                case 'name':
                    for (const record of this.state.appointments_array){
                        if (record.name.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;

                case 'number':
                    for (const record of this.state.appointments_array){
                        if (record.employee_number.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
 
                case 'rom':
                    for (const record of this.state.appointments_array){
                        if (record.reports_to_rom.includes(filterObj.search_string)){
                            temp_array.push(record);
                        }
                    }
                    break;
            
                default:
                    break;
            }
            this.setState({filtered_assessments_array: temp_array, filter_applied:true});
        }
    }   

    render() {return(
        <Grid
            container
            direction='column'
            // justifyContent='flex-start'
            // alignContent='flex-start'
            // style={{backgroundColor:'yellow'}}
        >
            <Grid item>
            <Paper
                elevation={3}
                style={{
                    // backgroundColor:'yellow',
                    width:1280
                }}
            >

                <Grid
                    container
                    // style={{backgroundColor:'yellow'}}
                    justifyContent='center'
                    alignContent='center'
                >

                    <Grid item xs={3}>
                        <div style={{display:'flex', justifyContent:'space-evenly', alignItems:"center"}}>
                            <Tooltip title="Export to Excel">
                            <span>
                            <IconButton 
                                aria-label='Export to Excel'
                                onClick={this.exportMe}
                                disabled={this.state.filtered_assessments_array.length===0}
                            >
                                <ExcelLogo />
                            </IconButton>
                            </span>
                            </Tooltip>
                        </div>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography
                            style={{padding:10}}
                        >
                            <b>OHS Certificate Alerts</b><br/>(OHS role appointments with missing, expired or expiring certification)
                        </Typography>
                    </Grid>

                    <Grid item xs={3}>
                        <Grid 
                            container
                            alignItems='center'
                            justifyContent='space-evenly'
                            // style={{backgroundColor:'yellow'}}
                        >
                            <FilterBox
                                setParentFilter={this.handleFilterChange}
                                data_populated={this.state.appointments_array.length>0? true : false}
                                filter_applied={this.state.filter_applied}
                                filter_obj={this.state.filter_obj}
                                show_hod_filter={true}
                                // show_branch_filter={true}
                                // show_cycle_filter={true}
                            />
                        </Grid>
                    </Grid>

                </Grid>


                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.filtered_assessments_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying}
                    deleteHeaderName={'Delete'}
                    pagesize={10}
                    height={500}
                />

            </Paper>
            </Grid>

            <Grid item>
                <Typography color='secondary' style={{Width:1280,maxWidth:1280, textAlign:'center'}}>{this.state.error_message}</Typography>
                {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
            </Grid>

        </Grid>
    )}
    
}